<!-- #63 -->
<template>
  <v-col class="mx-4">
    <div class="d-flex">
      <div
        class="text-h6 py-0 my-0 pl-0"
        style="color: #23468c; font-weight: 500"
      >
        {{ +$route.params.id === 0 ? "Add a New" : "Edit" }} Client
      </div>
    </div>
    <v-divider class="mt-1 mb-4"></v-divider>
    <v-card class="pb-0">
      <v-card-title>
        <span class="body-1 font-weight-bold"
          >{{ +$route.params.id === 0 ? "Add" : "Edit" }}

          <i class="caption red--text ml-4"> * required field</i>
        </span>
      </v-card-title>
      <v-divider></v-divider>
      <v-dialog v-model="opendialog" max-width="500px">
        <v-card>
          <v-card-title>
            <span class="headline">Uploaded Logo </span>
            <v-spacer />
            <v-btn icon @click="opendialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider class="mb-4"></v-divider>
          <v-card-text>
            <v-img :src="editedItem.base_64_logo"></v-img>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-card-text class="pb-0">
        <v-form ref="form" class="pb-0">
          <h3 class="pb-2">Client Info</h3>
          <v-row class="pb-0">
            <v-col cols="12" sm="6" md="6" class="pb-0">
              <v-text-field
                v-model="editedItem.name"
                label="Client Legal Name"
                :rules="[
                  (v) => (v && !!v.trim()) || 'Client Legal name is required.',
                ]"
                class="required pb-0"
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6" class="pb-0">
              <v-text-field
                v-model="editedItem.display_client_name"
                dense
                label="Display Client Name"
                :rules="[
                  (v) =>
                    (v && !!v.trim()) || 'Display Client Name is required.',
                ]"
                class="required pb-0"
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6" class="pb-0 pt-0">
              <v-text-field
                v-model="editedItem.client_website"
                dense
                label="Client Website URL"
                type="url"
                placeholder="https://"
                outlined
                class="pb-0"
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              :sm="$route.params.id > 0 && editedItem.base_64_logo ? 5 : 6"
              :md="$route.params.id > 0 && editedItem.base_64_logo ? 5 : 6"
              class="pb-0 pt-0"
            >
              <v-file-input
                v-model="file_input"
                accept="image/png, image/jpeg"
                placeholder="Pick a logo"
                label="Logo"
                outlined
                dense
                prepend-icon=""
                prepend-inner-icon="mdi-paperclip"
              ></v-file-input>
            </v-col>
            <v-col
              cols="12"
              sm="1"
              md="1"
              class="pb-0 pt-0"
              v-if="$route.params.id > 0 && editedItem.base_64_logo"
            >
              <v-icon @click="opendialog = true">mdi-image</v-icon>
            </v-col>
            <v-col cols="12" sm="6" md="6" class="pb-0 pt-0">
              <v-autocomplete
                label="Service"
                :items="allClientServices"
                v-model="editedItem.service"
                :rules="[(v) => !!v || 'Service is required.']"
                dense
                class="required pb-0"
                outlined
              ></v-autocomplete>
            </v-col>
            <v-col
              cols="12"
              sm="6"
              md="6"
              v-if="editedItem.service == 'ior'"
              class="pb-0 pt-0"
            >
              <v-text-field
                v-model="editedItem.crm_value"
                dense
                label="CRM Append Variable"
                :rules="[
                  (v) =>
                    (v && !!v.trim()) || 'CRM append variable is required.',
                ]"
                class="required pb-0 pt-0"
                outlined
              ></v-text-field>
            </v-col>

            <v-col
              cols="12"
              sm="6"
              md="6"
              v-if="editedItem.service == 'ior'"
              class="pb-0 pt-0"
            >
              <v-text-field
                v-model="editedItem.url_value"
                dense
                label="URL Naming Conventione"
                :rules="[
                  (v) =>
                    (v && !!v.trim()) || 'URL naming conventionis required.',
                ]"
                class="required pb-0 pt-0"
                outlined
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              sm="6"
              md="6"
              class="pb-0 pt-0"
              v-if="
                editedItem.service == 'fulfillment' ||
                editedItem.service == 'fulfillment_wid_last_mile'
              "
            >
              <v-autocomplete
                label="Type of business"
                :items="business"
                v-model="editedItem.type_of_business"
                :rules="[(v) => !!v || 'Type of business is required.']"
                class="required pb-0 pt-0"
                outlined
                dense
              ></v-autocomplete>
            </v-col>

            <v-col
              cols="12"
              sm="6"
              md="6"
              v-if="
                editedItem.service == 'fulfillment' ||
                editedItem.service == 'fulfillment_wid_last_mile'
              "
              class="pb-0 pt-0"
            >
              <v-autocomplete
                label="Zone"
                :items="zones"
                v-model="editedItem.zone"
                :rules="[(v) => !!v || 'Zone is required.']"
                class="required pb-0"
                outlined
                dense
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="6" md="6" class="pb-0 pt-0">
              <v-autocomplete
                label="Client country"
                :items="allCountries"
                v-model="editedItem.country_code"
                :rules="[(v) => !!v || 'Country is required.']"
                class="required pb-0"
                outlined
                dense
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="6" md="6" class="pb-0 pt-0">
              <v-autocomplete
                label="Status"
                :items="statuses"
                v-model="editedItem.active"
                dense
                :rules="[
                  (v) => (v !== '' && v !== null) || `Status is required.`,
                ]"
                class="required pb-0"
                outlined
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="6" md="6" class="pb-0 pt-0">
              <v-text-field
                v-model="editedItem.ramco_client_id"
                label="Ramco Client ID"
                outlined
                class="pb-0"
                dense
              ></v-text-field>
            </v-col>
          </v-row>
          <v-divider class="mb-5"></v-divider>
          <h3 class="pt-0 mb-2">POC</h3>
          <v-row class="pb-0">
            <v-col cols="12" sm="6" md="4" class="pb-0">
              <v-text-field
                v-model="editedItem.contact_name"
                label="Primary Contact Name"
                dense
                class="pb-0"
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4" class="pb-0">
              <v-text-field
                v-model="editedItem.email"
                dense
                label="Primary Contact Email"
                class="pb-0"
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4" class="pb-0">
              <v-text-field
                v-model="editedItem.contact_phone_no"
                dense
                label="Primary Contact Phone"
                class="pb-0"
                outlined
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row class="pb-0">
            <v-col
              cols="12"
              sm="6"
              md="6"
              v-if="editedItem.service == 'ior'"
              class="pb-0"
            >
              <v-text-field
                v-model="editedItem.crm_value"
                dense
                label="CRM Append Variable"
                :rules="[
                  (v) =>
                    (v && !!v.trim()) || 'CRM append variable is required.',
                ]"
                class="required pb-0 pt-0"
                outlined
              ></v-text-field>
            </v-col>

            <v-col
              cols="12"
              sm="6"
              md="6"
              v-if="editedItem.service == 'ior'"
              class="pb-0"
            >
              <v-text-field
                v-model="editedItem.url_value"
                dense
                label="URL Naming Conventione"
                :rules="[
                  (v) =>
                    (v && !!v.trim()) || 'URL naming conventionis required.',
                ]"
                class="required pb-0 pt-0"
                outlined
              ></v-text-field>
            </v-col>
          </v-row>
          <!-- <v-row>
            <v-col cols="12" sm="6" md="4">
              <v-radio-group
                row
                v-model="editedItem.duty_handling"
                label="Duty Handling"
                hide-details="auto"
              >
                <v-radio label="DDU" value="DDU"></v-radio>
                <v-radio label="DDP" value="DDP"></v-radio>
              </v-radio-group>
            </v-col>
          </v-row> -->
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-btn
          v-if="$route.params.id == 0"
          color="primary"
          @click="save"
          :loading="loader"
          class="ma-2"
          >Save</v-btn
        >
        <v-btn
          v-if="$route.params.id > 0"
          color="primary"
          @click="save"
          :loading="loader"
          class="ma-2"
          >Update</v-btn
        >
        <v-btn
          v-if="$route.params.id > 0"
          class="ml-3"
          color="error"
          @click="$router.push('/clients')"
        >
          Cancel
        </v-btn>
      </v-card-actions>
    </v-card>

    <v-card class="mt-2" v-if="$route.params.id > 0 && editedItem.logo_name">
      <v-card-title>
        <span class="body-1 font-weight-bold">Delete Uploaded logo </span>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-form>
          <v-card>
            <v-simple-table dense>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">Logo</th>
                    <th class="text-left">Delete</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{{ editedItem.logo_name }}</td>
                    <td v-if="checkPermission('app_client:client_logo_delete')">
                      <v-btn
                        icon
                        color="red"
                        @click="openUnlinkedPopup(editedItem.logo_name)"
                      >
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card>
        </v-form>
      </v-card-text>
    </v-card>
    <v-dialog v-model="unlinkedDialog" max-width="290" persistent>
      <v-card>
        <v-card-title class="headline">Delete Logo</v-card-title>
        <v-divider class="mb-2"></v-divider>
        <v-card-text> Are you sure you want to delete this logo? </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="white" small @click="unlinkedDialog = false">
            Cancel
          </v-btn>

          <v-btn color="primary" small @click="unlinked()"> Delete </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-col>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import { countries, clientServices } from "@/config/data";
export default {
  computed: {
    ...mapGetters(["trackCategories"]),
    formTitle() {
      return this.editedIndex === -1 ? "Create" : "Edit";
    },
    allCountries() {
      return Object.keys(countries).map((i) => {
        return {
          text: countries[i],
          value: i,
        };
      });
    },
  },

  data: () => ({
    files: [],
    unlinkedDialog: false,
    fileInput: null,
    opendialog: false,
    statuses: [
      {
        text: "Active",
        value: true,
      },
      {
        text: "Inactive",
        value: false,
      },
    ],
    dialog: false,
    dialogDelete: false,
    dialogConfirm: false,
    headers: [
      {
        text: "Client Legal  Name",
        value: "name",
        class: "body-1 font-weight-bold",
      },
      {
        text: "Display Client Name",
        value: "display_client_name",
        class: "body-1 font-weight-bold",
      },
      {
        text: "Service",
        value: "service",
        class: "body-1 font-weight-bold",
      },
      {
        text: "Country",
        value: "country_name",
        class: "body-1 font-weight-bold",
      },
      {
        text: "Ramco Client ID",
        value: "ramco_client_id",
        class: "body-1 font-weight-bold",
      },
      {
        text: "Primary Email Id",
        value: "email",
        class: "body-1 font-weight-bold",
      },
      {
        text: "Status",
        value: "active",
        class: "body-1 font-weight-bold",
      },
      {
        text: "Actions",
        value: "actions",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
    ],
    editedIndex: -1,
    editedItem: {
      name: "",
      display_client_name: "",
      client_website: "",
      country_code: "",
      active: null,
      email: null,
      status: "",
      service: "",
      ramco_client_id: "",
      contact_name: "",
      contact_phone_no: "",
      crm_value: "",
      url_value: "",
      type_of_business: "",
      zone: "",
    },
    file_input: null,
    defaultItem: null,
    clients: [],
    options: {},
    total: 0,
    clientsLoader: false,
    search: null,
    saveLoader: false,
    deleteLoader: false,
    statusLoader: false,
    dialogInvite: false,
    inviteLoader: false,
    name: "",
    display_client_name: "",
    email: "",
    country_code: "",
    service: "",
    active: "",
    filtersArr: {},
    business: ["B2C", "B2B"],
    zones: ["Local", "Freezone"],
    allClientServices: [],
  }),

  watch: {
    dialog(val) {
      val || this.close();
      if (this.editedIndex === -1) {
        this.editedItem = Object.assign({}, this.defaultItem);
      }
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },
  mounted() {
    if (+this.$route.params.id) {
      this.fetchClientDetails();
    }
  },
  created() {
    this.defaultItem = Object.assign({}, this.editedItem);
    if (this.$route.params.id == 0) this.getClientAddLists();
  },

  methods: {
    ...mapActions([
      "getClients",
      "createClient",
      "updateClient",
      "sendClientInvite",
      "snackBar",
      "getClientAddList",
      "getClient",
      "unlinkedLogo",
    ]),
    unlinked() {
      let payload = {
        logo_name: this.editedItem.logo_name,
      };
      let data = {
        data: payload,
        id: this.$route.params.id,
      };
      this.unlinkedLogo(data).then((res) => {
        this.snackBar({ message: res.data.message, color: "success" });
        this.unlinkedDialog = false;
        this.fetchClientDetails();
      });
    },
    openUnlinkedPopup(file) {
      this.unlinkedDialog = true;
      this.filetoUnlinked = file;
    },
    fetchClientDetails() {
      this.getClient(this.$route.params.id).then((res) => {
        this.editedItem = res.data;
        this.editedItem.base_64_logo = res.data.base_64_logo;
        this.allClientServices = Object.keys(
          res.data.drop_down_list.list_client_service_choice
        ).map((i) => {
          return {
            text: clientServices[i],
            value: i,
          };
        });
      });
    },
    getClientAddLists() {
      this.getClientAddList().then((res) => {
        this.allClientServices = Object.keys(
          res.data.list_client_service_choice
        ).map((i) => {
          return {
            text: clientServices[i],
            value: i,
          };
        });
      });
    },
    save() {
      if (!this.$refs.form.validate()) {
        return;
      }

      this.saveLoader = true;
      var formData = new FormData();
      formData.delete("logo");

      for (let key in this.editedItem) {
        if (this.editedItem[key] !== null && this.editedItem[key] !== "") {
          formData.append(key, this.editedItem[key]);
        }
      }
      if (typeof formData.get("active") == "string") {
        formData.delete("active");
        if (this.editedItem.active == true) {
          formData.append("active", this.editedItem.active);
        } else {
          formData.append("active", false);
        }
      }
      if (this.file_input)
        formData.append("logo", this.file_input, this.file_input.name);
      formData.delete("drop_down_list");
      formData.delete("base_64_logo");

      if (+this.$route.params.id) {
        this.updateClient({
          id: this.editedItem.id,
          data: formData,
        })
          .then((res) => {
            this.saveLoader = false;
            this.snackBar({
              color: "success",
              message: res.data.message,
            });
            this.$router.push("/clients");
          })
          .catch(() => {
            this.saveLoader = false;
          });
      } else {
        this.createClient(formData)
          .then((res) => {
            this.saveLoader = false;
            this.snackBar({
              color: "success",
              message: res.data.message,
            });
            this.$router.push("/clients");
            this.close();
          })
          .catch(() => {
            this.saveLoader = false;
          });
      }
    },
    confirmStatusChange(item) {
      this.editedIndex = this.clients.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogConfirm = true;
    },

    changeStatus() {
      this.statusLoader = true;
      this.updateClient({
        id: this.editedItem.id,
        data: this.editedItem,
      })
        .then((res) => {
          this.statusLoader = false;
          this.snackBar({
            color: "success",
            message: res.data.message,
          });
          this.dialogConfirm = false;
          this.reset();
        })
        .catch(() => {
          this.statusLoader = false;
          this.closeConfirm();
        });
    },

    sendInvite() {
      this.inviteLoader = true;
      this.sendClientInvite({
        client_ids: [this.editedItem.id],
      })
        .then((res) => {
          this.inviteLoader = false;
          this.snackBar({
            color: "success",
            message: res.data.message,
          });
          this.dialogInvite = false;
        })
        .catch(() => {
          this.inviteLoader = false;
        });
    },

    goToMapping(item) {
      this.$router.push({
        name: "ProductHSCodeMap",
        params: {
          id: item.id,
        },
        query: {
          name: item.name,
        },
      });
    },

    goToMapSeller(item) {
      this.$router.push({
        name: "MapSellers",
        params: {
          id: item.id,
        },
        query: {
          name: item.name,
        },
      });
    },

    goToddress(item) {
      this.$router.push({
        name: "ClientAddresses",
        params: {
          id: item.id,
        },
      });
    },

    clearInput(val) {
      if (val !== null) {
        val = "";
      }
    },
    clearAll() {
      (this.name = ""),
        (this.display_client_name = ""),
        (this.email = ""),
        (this.country_code = ""),
        (this.service = ""),
        (this.active = "");
      this.searchAll();
    },

    allFilters() {
      this.orderLoader = true;
      let obj = {
        name: this.name,
        display_client_name: this.display_client_name,
        email: this.email,
        country_code: this.country_code,
        service: this.service,
        active: this.active,
      };
      Object.keys(obj).forEach((key) => {
        if (obj[key] === null || obj[key] === undefined || obj[key] === "") {
          delete obj[key];
        }
      });
      this.filtersArr = obj;
    },
    searchAll() {
      this.options.page = 1;
      this.allFilters();
      this.getClients({
        ...this.options,
        ...this.filtersArr,
      })
        .then((res) => {
          this.clientsLoader = false;
          this.clients = res.data.records;
          this.total = res.data.total;
        })
        .catch(() => {
          this.clientsLoader = false;
        });
    },
    token(item) {
      this.$router.push({
        name: "ClientToken",
        params: {
          id: item.id,
        },
      });
    },
    getServiceName(key) {
      return clientServices[key];
    },
  },
};
</script>
